import CheckIcon from "@mui/icons-material/Check";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { formToObject } from "../../../utils";

import {
  _UPDATE_USER_PASSWORD,
  _VIEW_USER_LOGIN_PASSWORD,
} from "../../../models/userLoginModel";
import { _LIST_USER_ROLES } from "../../../models/rbacModel";

const EditUserPasswordComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [roles, setRoles] = useState([]);
  const [loginData, setLoginData] = useState([]);
  const { openDialog } = useDialog();

  useEffect(() => {
    console.log(props.dataSource);
    _VIEW_USER_LOGIN_PASSWORD({ id: props.dataSource.login_id }).then((res) => {
      if (res.status == "1") {
        setLoginData(res.data);
      } else {
        setLoginData([]);
      }
      setLoader(false);
    });
    listRoles();
  }, []);

  const listRoles = () => {
    setLoader(true);
    _LIST_USER_ROLES({ status: "1" }).then((res) => {
      if (res.status == "1") {
        setRoles(res.data);
      } else {
        setRoles([]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_USER_PASSWORD(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  const field = (fieldName) => props.dataSource[fieldName] || "";

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="id" value={field("id")} />

          <Row>
            <Col md={3}>
              <PsLabel text="Username" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="username"
                placeholder="Username"
                defaultValue={field("username")}
                size="sm"
                readOnly
                className="fw-bold bg-light"
                required
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Password" />
            </Col>
            <Col md={9}>
              <InputGroup size="sm">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  defaultValue={loginData.password}
                  size="sm"
                  className="fw-bold"
                  autoComplete="off"
                />
                <InputGroup.Text
                  className="cursor-pointer"
                  onClick={(e) => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <VisibilityOffIcon fontSize="small" />
                  ) : (
                    <VisibilityIcon fontSize="small" />
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Role" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="role_uid"
                size="sm"
                className="fw-bold form-select form-select-sm"
                autoFocus
                required
              >
                <option value="">-Select-</option>
                {roles.map((item) => (
                  <option
                    value={item.id}
                    selected={item.id == field("role_uid") ? "selected" : ""}
                  >
                    {item.role_name}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const EditUserPassword = (props) => {
  return (
    <>
      <PsModalWindow size="md" title="Edit User Password" {...props}>
        {props.show && <EditUserPasswordComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default EditUserPassword;
